import { render } from "./pagination.vue?vue&type=template&id=5200b41b&scoped=true&ts=true"
import script from "./pagination.vue?vue&type=script&lang=ts"
export * from "./pagination.vue?vue&type=script&lang=ts"

import "./pagination.vue?vue&type=style&index=0&id=5200b41b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5200b41b"]])

export default __exports__